import * as React from 'react'
import ItemRow from '../../../../common/ItemRow'
import Location from '../../adLocations/Location'
import { Article, Variation } from '../articlesContainer'
import ArticleTabs from './ArticleTabs'
import { AdFormats } from '../../adFormat/adFormat'

interface ArticlesProps {
	articles: Article[]
	updateVariationField: (
		artUid: string,
		variationNum: number,
		field: keyof Variation,
		content: string,
		instant?: boolean,
	) => void
	duplicateVariation: (articleId: string, variationNo: number, instant?: boolean) => void
	removeVariation: (articleId: string, variationNo: number, instant?: boolean) => void
	addVariation: (articleId: string, instant?: boolean) => void
	updateArticle: (art: Article, instant?: boolean) => void
	selectedLocations?: Location[]
	showInstantArticleModal?: (article: string) => void
	activeTab?: number
	instant?: boolean
	showVariations?: boolean
	client?: {
		id: number
		org: string
	}
	campaignId?: number
	hasUnsavedChanges?: boolean
	adFormat: AdFormats
}

const Articles: React.FunctionComponent<ArticlesProps> = (props) => {
	return (
		<>
			{props.articles.length > 0 && (
				<ItemRow name="article_buttons">
					<ArticleTabs
						articles={props.articles}
						updateVariationField={props.updateVariationField}
						duplicateVariation={props.duplicateVariation}
						removeVariation={props.removeVariation}
						addVariation={props.addVariation}
						updateArticle={props.updateArticle}
						selectedLocations={props.selectedLocations}
						showInstantArticleModal={props.showInstantArticleModal}
						activeTab={props.activeTab}
						instant={props.instant}
						showVariations={props.showVariations}
						client={props.client}
						campaignId={props.campaignId}
						hasUnsavedChanges={props.hasUnsavedChanges || false}
						adFormat={props.adFormat}
					/>
				</ItemRow>
			)}
		</>
	)
}
export default Articles
